import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { map, Observable } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

type CanDeactivateType = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;

export interface CanComponentDeactivate {
  canDeactivate: () => CanDeactivateType;
}


@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard   {

  constructor(public dialog: MatDialog, private translocoService: TranslocoService) {}
  canDeactivate(
    component: CanComponentDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): CanDeactivateType {
      const canDeactivate = component.canDeactivate ? component.canDeactivate() : true;
      if (!canDeactivate) {
           return this.confirmNoSave();
      }
      return true;
  }

  confirmNoSave(): Observable<boolean> {
    const modal = {
      data: {
        modalInfo: {
          title: this.translocoService.translate('shared.unsavedChanges.title'),
          message: this.translocoService.translate('shared.unsavedChanges.message'),
          primaryBtnClass: 'blue',
          primaryBtnText: this.translocoService.translate('shared.unsavedChanges.exitWithoutSaving'),
          cancelText: this.translocoService.translate('shared.unsavedChanges.returnToPage'),
          showCancel: true,
        },
      },
    };

    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: modal,
      disableClose: true,
    });

    return dialogRef.afterClosed().pipe(
      map(result => result === true)
    );
  }
}
